import React from 'react';
import BootCamps from '../Layouts/MainPart/bootcamps/BootCamps';

function BootcampsPage() {
	return (
		<div className='bootcamp'>
			<BootCamps />
		</div>
	);
}

export default BootcampsPage;
